import styled from 'styled-components'

export const FillerOverlay = styled.div`
  background-color: ${({ theme }) => theme.palette.grey[50]};
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`

export const FillerBackdrop = styled.div`
  background-color: ${({ theme }) => theme.palette.black + 'AA'};
  backdrop-filter: grayscale();

  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`
